module.exports = __webpack_public_path__ + "img/programs3.ad3a4feb.svg";